<template>
  <div style="width: 100%;">
    <div v-if="model">
      <div class="main-content socstyle" :class="error ? ['error'] : []">
        <div class="main-content-heading">
          <h1>Dotazník sociánych štýlov</h1>
          <div class="back">
             <router-link :to="{name: 'questionary_all'}">&lt; Späť na dotazníky</router-link>
          </div>
        </div>
        <div class="heading-spliter"></div>
        <div class="text-mute">
          Dotazník sociálnych štýlov vychádza z výskumov a učenia Davida Merrilla a Rogera Reida. Zameriava sa
          na osobnostné črty, spôsob interakcie, komunikácie, ale aj na orientáciu na potreby druhých, vďaka čomu
          kategorizuje ľudí do viacerých základných typov.
          <br />
          <br /><b>Inštrukcia:</b>
          <br />
          <br />Zamyslite sa nad každou z nižšie uvedených ľudských vlastností a charakteristík a ohodnoťte sa,
          nakoľko vás vystihujú. Vyberte si z dvoch možností, ktorá pre Vás platí na škále:
          VYSTIHUJE (<b>V</b>): ak vás to vystihuje čiastočne až výrazne
          NEVYSTIHUJE (<b>N</b>): ak vás to vystihuje veľmi málo až vôbec
          <br />
          <br />Ohodnotiť musíte každú vlastnosť alebo charakteristiku.
          <br />
          <br />Príklad: Ak väčšinu situácii a problémov riešite skôr Logicky (aj keď nie všetky) označte
          <b>V</b> (VYSTIHUJE).
          <br />Naopak, keď ich riešite skôr emocionálne označte
          <b>N</b> (NEVYSTIHUJE).
        </div>
        <h2 style="padding-left:0;">{{model.questionary.lang.name}}</h2>
        <div class="main-content-box result" v-if="model.result && !model.questionary.hidden_results">
          <div class="left">Váš výsledok</div>
          <div class="right">
            <div class="finished">
              <div class="item">AN: {{Math.round(model.result.AN / model.result.SUM * 100)}}</div>
              <div class="item">VO: {{Math.round(model.result.DR / model.result.SUM * 100)}}</div>
              <div class="item">EX: {{Math.round(model.result.EX / model.result.SUM * 100)}}</div>
              <div class="item">LA: {{Math.round(model.result.LA / model.result.SUM * 100)}}</div>
              <div class="item hide_mobile_flex">
                <a
                  style="color: inherit; text-transform: none;"
                  target="_blank"
                  :href="pdfUrl+'/api/public/questionary/pdf?arr='+model.pdf"
                >
                  <img style="width: 14px;" src="/static/download.svg" />&nbsp; Stiahnúť report
                </a>
              </div>
            </div>
            <div class="finished show_mobile_flex">
              <a
                style="color: inherit; text-transform: none;"
                target="_blank"
                :href="pdfUrl+'/api/public/questionary/pdf?arr='+model.pdf"
              >
                <img style="width: 14px;" src="/static/download.svg" />&nbsp; Stiahnúť report
              </a>
            </div>
          </div>
          
        </div>
        <div v-if="model.result && !model.questionary.hidden_results">
            <i>Výsledná hodnota sčítaním jednotlivých štýlov predstavuje 100%. Môže však nastať prípad, kedy Vaša výsledná hodnota po sčítaní bude 99 alebo 101 z dôvodu zaokruhľovania výsledkov pri jednotlivých štýloch. </i>
          </div>
        <div class="middle">
          <div
            style="float:left; width: 100%; padding: 18px 20px 5px 28px; border-bottom: 2px #ccc solid; color: #b11116;"
          >
            <div style="float: right; padding-right: 0px;">{{page + 1}} / 14</div>
          </div>
          <div style="background: transparent; border: 0;" class="main-content-box ls q">
            <div class="left"></div>
            <div class="right" style="flex-direction: row;">
              <div class="cel1">Vystihuje</div>
              <div class="cel1">Nevystihuje</div>
            </div>
          </div>

          <div
            v-for="question,key in questionModel"
            class="main-content-box ls q"
            v-if="key >= page*10 && key < (page*10) + 10"
          >
            <div class="left">
              <label
                :class="question.model === null ? ['empty'] : ['filled']"
              >{{question.question.text}}</label>
            </div>

            <div class="right" style="flex-direction: row;">
              <div class="cel1">
                <div
                  :class="['selector',question.model === '1' ? 'sel' :'']"
                  @click="saveQuestion(question, '1')"
                >V</div>
              </div>

              <div class="cel1">
                <div
                  :class="['selector',question.model === '0' ? 'sel' :'']"
                  @click="saveQuestion(question, '0')"
                >N</div>
              </div>

              <!--<span class="cel" style="width: 120px; margin-right: 25px;">
              <input
                :disabled="!!model.result"
                type="radio"
                :id="'ls_question_' + question.question.local_id+ '_y'"
                value="0"
                v-model="question.model"
                @change="saveQuestion(question)"
              />
              <label :for="'ls_question_' + question.question.local_id+ '_y'">Vystihuje ma</label>
            </span>
            <span class="cel" style=" width: 125px;">
              <input
                :disabled="!!model.result"
                type="radio"
                :id="'ls_question_' + question.question.local_id+ '_no'"
                value="1"
                v-model="question.model"
                @change="saveQuestion(question)"
              />
              <label :for="'ls_question_' + question.question.local_id + '_no'">Nevystihuje ma</label>
              </span>--->
            </div>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <a
              style="width: 150px;"
              class="button"
              :class="page > 0 ? '' : 'hidden'"
              @click="page--"
            >Naspäť</a>
            <a
              style="width: 150px;"
              class="button"
              v-if="page < 13"
              :class="page < 13? '' : 'hidden'"
              @click="page++"
            >Ďalej</a>
            <a
              style="margin-left: 15px;"
              v-if="!model.result && page == 13"
              @click="close"
              class="button"
            >Odoslať dotazník ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormBase from "../../elements/FormBase";
import { required, email } from "vuelidate/lib/validators";
import RangeSlider from "vue-range-slider";
import Vue from "vue";
import _ from "lodash";
import server from "../../api/server";
export default {
  components: {
    RangeSlider
  },
  mixins: [FormBase],
  props: ["model"],
  data() {
    return {
      questionModel: null,
      error: false,
      page: 0,
      max: 140,
      pdfUrl: server.baseUrl,
      savedQuestions: [],
      timeout: null
    };
  },
  mounted() {},
  created() {
    this.timeout = setInterval(() => {
      this.save();
    }, 2500);
  },
  destroyed() {
    clearInterval(this.timeout);
  },
  methods: {
    changeVal(question, e) {
      this.$forceUpdate();
    },
    saveQuestion(question, val) {
      if (this.model.result) {
        return;
      }
      this.$forceUpdate();
      question.model = val;
      this.savedQuestions.push({
        id: this.model.id,
        lang_id: this.$api.translator.getCurrent(),
        local_id: question.question.local_id,
        value: question.model
      });
    },
    save() {
      if (this.savedQuestions.length > 0) {
        this.$forceUpdate();
        let q = this.savedQuestions;
        this.savedQuestions = [];
        this.$api.server
          .post("api/public/questionary/questions/save_all", {
            arr: JSON.stringify(q)
          })
          .then(r => {
            this.$api.bus.trigger(
              "course-status-change",
              this.model.id,
              r.data.progress
            );
          })
          .catch(() => {
            alert("Chyba pri ukladaní dát. Obnovte stránku prosím.");
          });
      }
    },
    check() {
      return true;
    },
    close() {
      var self = this;
      if (!this.check()) {
        self.$api.toaster.fail({ txt: "Vyplnte všetky polia" });
        return;
      }
      this.save();
      this.$api.bus.trigger("open-modal", {
        header: "Odoslať dotazník na hodnotenie ?",
        message: "Odoslať dotazník na hodnotenie ?",
        okBtn: "Áno",
        closeBtn: "Nie",
        cb() {
          self.$api.server
            .post("api/public/questionary/questions/close", {
              id: self.model.id,
              lang_id: self.$api.translator.getCurrent()
            })
            .then(r => {
              if (r.data.result) {
                window.location.reload();
              } else {
                self.$api.toaster.fail({
                  txt: "Vyplňte prosím všetky otázky."
                });
                self.error = true;
              }
            });
        }
      });
    }
  },
  computed: {},
  watch: {
    model: {
      handler() {
        if (!this.model) return;
        this.questionModel = [];
        var self = this;
        for (var i in this.model.questions) {
          //this.model.questions[i] = new Vue({data:()=>{return {...self.model.questions[i]};}});
          this.questionModel[i] = new Vue({
            data: () => {
              return { ...self.model.questions[i] };
            }
          });
          this.questionModel[i].model = this.model.questions[i].result
            ? this.model.questions[i].result.value
            : null;
        }
      },
      immediate: true,
      deep: false
    }
  },
  validations() {}
};
</script>
<style lang="css">
@media only screen and (min-width: 1200px) {
  .middle {
    margin-left: 13%;
    width: 74%;
  }
}
.hidden {
  visibility: hidden;
}
.cel1 {
  width: 120px;
  text-align: center;
}

@media screen and (max-width: 575.98px) {
  .cel1 {
    width: 50%;
  }
  main .content .main-content .main-content-box {
    flex-direction: row;
  }

  main .content .main-content .main-content-box .left {
    width: 40%;
  }

  main .content .main-content .main-content-box .right {
    width: 60%;
  }
}

.selector {
  padding: 3px 7px;
  border: 1px solid;
  display: inline-block;
  font-weight: bold;
}
.sel {
  color: white;
  font-weight: bold;
  background: #b11116;
  border-color: #b11116;
}
.center .range-slider {
  width: 90%;
}
.center {
  text-align: center;
}

a {
  cursor: pointer;
}
.center.disabled .range-slider-fill {
  width: 0px !important;
}
.main-content .ls .right .cel {
  font-weight: normal;
  display: inline-flex;
  align-items: center;
  flex-direction: row-reverse;
}

.main-content .ls .right .cel input {
  display: inline-block;
  float: right;
}
.main-content .ls .right .cel label {
  display: inline-block;
  float: left;
}

.main-content .ls .right .cel input[type="radio"]:checked + label {
  font-weight: bold;
}
.left {
  align-items: center;
  display: flex;
}
.left .empty {
  font-weight: bold;
}

.error .left .empty {
  color: red;
  font-weight: bold;
}

.left .filled {
  font-weight: normal;
}
@media screen and (max-width: 575.98px) {
  main .content .main-content.socstyle .main-content-box.result {
    flex-direction: column !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/public_app/pages/questionary/SocStyleForm.vue